import React from 'react';
import CardHolders from './cardHolders';  // Updated import

const Home = () => {
  return (
    <>
      <div className="text-center mt-4">
        <h1 className="display-4">Welcome to My Profile!</h1>
      </div>

      {/* Render CardHolders component */}
      <div className="mt-5">
        <CardHolders />
      </div>
    </>
  );
};

export default Home;
